module.exports = __webpack_public_path__ + "img/footer-m-th.4f5ba42b.png";